import * as yup from "yup";
import getByteLength from "@cores/getByteLength";

/**
 * Array unique validation method for yup
 * 배열 내 중복 값을 검증하고, 중복된 값의 인덱스를 반환합니다.
 *
 * yup.array().unique("Duplicate value.", (v) => v)
 */
yup.addMethod(yup.array, "unique", function (message, mapper = (a) => a) {
    return this.test("unique", message, function (list) {
        const mappedArray = list.map(mapper);
        const set = new Set(mappedArray);
        if (set.size !== mappedArray.length) {
            const duplicateIndexes = [];
            const valueCount = {};
            mappedArray.forEach((value, index) => {
                if (!value) return;

                if (!valueCount[value]) {
                    valueCount[value] = { count: 1, indexes: [index] };
                } else {
                    valueCount[value].count += 1;
                    valueCount[value].indexes.push(index);
                }
            });

            for (const value in valueCount) {
                if (valueCount[value].count > 1) {
                    duplicateIndexes.push(...valueCount[value].indexes);
                }
            }
            // 중복된 값의 인덱스를 반환합니다.
            return this.createError({
                path: `${duplicateIndexes}`,
                message: `Already exists. Try something else.`,
            });
        }
        return true;
    });
});

yup.addMethod(yup.string, "maxBytes", function (max, message) {
    return this.test({
        name: "maxBytes",
        message: message || `This field can be up to ${max} bytes.`,
        params: { maxBytes: max },
        test: function (value) {
            if (!value) return true;
            const byteLength = getByteLength(value);

            if (byteLength > max) {
                return this.createError({
                    message: message || `This field can be up to ${max} bytes.`,
                    path: this.path,
                });
            }
            return true;
        },
    });
});

yup.addMethod(yup.string, "minBytes", function (min, message) {
    return this.test({
        name: "minBytes",
        message: message || `This field can be at least ${min} bytes.`,
        params: { minBytes: min },
        test: function (value) {
            if (!value) return true;
            const byteLength = getByteLength(value);
            if (byteLength < min) {
                return this.createError({
                    message: message || `This field can be at least ${min} bytes.`,
                    path: this.path,
                });
            }
            return true;
        },
    });
});

export default yup;
